import { graphql } from "../gql";

export const submitFeedbackMutation = graphql(`
  mutation submitFeedback($input: SubmitFeedbackInput!) {
    submitFeedback(input: $input)
  }
`);
